import { ComponentSize } from '@conekta/frontino-ui/common/constants';
import { Icon } from '@conekta/frontino-ui/Icon';
import { ImgWrapper } from 'app/pages/frames/components/styled-components/ImgWrapper';
import { MAX_LENGTH_MERCHANT_NAME } from 'app/pages/hosted-checkout/constants';
import { getLogo } from 'app/util/images';
import classNames from 'classnames';

import './styles.scss';
import { useEffect, useState } from 'react';

const Logo = ({ theme, merchantName }: LogoProps) => {
  const [size, setSize] = useState('');
  const [imgLogo, setImgLogo] = useState('');
  let logo;

  useEffect(() => {
    if (theme) {
      const { imgLogo: logoTheme, size: sizeTheme } = getLogo(theme.logo);
      setSize(sizeTheme);
      setImgLogo(logoTheme);
    }
  }, []);

  if (theme) {
    logo = <ImgWrapper src={imgLogo} {...{ size }} alt='logo' className='logo__image' />;
  } else {
    logo = <DefaultLogoWithMerchantName merchantName={merchantName} />;
  }

  return <div className='logo'>{logo}</div>;
};

interface LogoProps {
  merchantName: string;
  theme: Record<string, any>;
}

export default Logo;

const DefaultLogoWithMerchantName = ({ merchantName }: any) => {
  const lengthString = merchantName.length;

  return (
    <>
      <Icon size={ComponentSize.LARGE} className='logo__icon'>
        store
      </Icon>
      <p
        className={classNames(
          'logo__merchant-name',
          lengthString >= MAX_LENGTH_MERCHANT_NAME ? 'logo__merchant-name__nameSmall' : '',
        )}
      >
        {merchantName}
      </p>
    </>
  );
};
